import React, { useEffect } from 'react';
import { proceeToLink, } from "../../../Common/Appcommon";

const getPabbly = () => {
  window.open("https://www.pabbly.com/connect/integrations/cratio-crm/", '_blank');
};

const PabblyIntegration = () => {
  useEffect(() => {
    getPabbly();
    proceeToLink("/#/settings", true);
  }, []); 
};

export default PabblyIntegration;
